import DataVizSpinoffs from '../sections/alta-formazione/dataviz-spinoffs';
import DataVizUstatPostgraduatesMaster from '../sections/alta-formazione/dataviz-ustat-postgraduates-master';
import DataVizUstatIsotypesMaster from '../sections/alta-formazione/dataviz-ustat-isotypes-master';
import DataVizUstatPostgraduatesPHD from '../sections/ricerca-innovazione/dataviz-ustat-postgraduates-phd';
import DataVizUstatIsotypesPHD from '../sections/ricerca-innovazione/dataviz-ustat-isotypes-phd';
import DataVizErasmusPlus from '../sections/alta-formazione/dataviz-erasmusplus';
import DataVizPublicationsBumpchart from '../sections/ricerca-innovazione/dataviz-publications-bumpchart';
import DataVizNetworkCTN from '../sections/reti-collaborazione/dataviz-network-ctn';
import DataVizNetworkCORDIS from '../sections/reti-collaborazione/dataviz-network-cordis';
import * as d3 from 'd3';
import { createHashHistory } from "history"
import iconSchool from '../images/cards-icons/021-school.svg';
import iconGeo from '../images/cards-icons/014-geography.svg';
import iconDiploma from '../images/cards-icons/007-certification.svg';
import iconDiploma2 from '../images/cards-icons/008-certification.svg';
import iconBoard from '../images/cards-icons/005-bulletin board.svg';
import iconTeacher from '../images/cards-icons/027-teacher.svg';
import iconMagnet from '../images/cards-icons/031-magnet.svg';
import iconMagnet2 from '../images/cards-icons/032-magnet.svg';
// import iconFlask from '../images/cards-icons/013-flasks.svg';
import iconRocket from '../images/cards-icons/051-rocket.svg';
import iconNetwork from '../images/cards-icons/037-molecules.svg';
import iconNetwork2 from '../images/cards-icons/009-stem cells.svg';

import { strings } from '../common/translations';
import { LANG } from '../common/constants';
strings.setLanguage(LANG);

// "http://www.sirislab.com/lab/fst-tor-dashboard/esplora-i-dati"
// "http://www-stg.toscanaopenresearch.it/esplora-i-dati"
// "http://www.sirislab.com/lab/fst-tor-dashboard/explore-the-data"
// "http://www-stg.toscanaopenresearch.it/explore-the-data"


export const settings = {
  VIZ_URL: process.env.NODE_ENV === "development" ? "http://localhost:9000/#!/chart-catalogue/" : "./" + LANG + "/#!/chart-catalogue/"
}

export const history = createHashHistory();

export function wrapMultiLineText(text, width) {
  // text.each(function() {
  //     var text = d3.select(this),
  //         words = text.text().split(/\s+/).reverse(),
  //         word,
  //         line = [],
  //         lineNumber = 0,
  //         lineHeight = 1.05, // ems
  //         y = text.attr("y"),
  //         tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", 0),
  //         tspans = [];

  //     while (words.length > 0) {
  //         word = words.pop()
  //         line.push(word);
  //         tspan.text(line.join(" "));
  //         if (tspan.node().getComputedTextLength() > width) {
  //             line.pop();
  //             tspan.text(line.join(" "));
  //             line = [word];
  //             tspan = text.append("tspan").attr("x", 0).attr("y", ++lineNumber * lineHeight + "em").text(word);
  //             tspans.push(tspan)
  //         }
  //     }

  //     tspans.forEach(t => t.attr('y', (t.attr('y').slice(0,-2) - (lineNumber * lineHeight/2)) + 'em'))
  //     text.attr('y', y - (lineNumber * lineHeight/2) )
  // });
  text.each(function () {
    var text = d3.select(this),
      truncate = text.text().length > 75 ? text.text().substring(0, 75) + "..." : text.text(),
      words = truncate.split(/\s+/).reverse(),
      word,
      line = [],
      // lineNumber = 0,
      lineHeight = parseInt(text.style("font-size")), // ems
      // fontSize = width / 8,
      // x = text.attr("x"),
      y = text.attr("y"),
      dy = 0, //parseFloat(text.attr("dy")),
      tspan = text.text(null)
        .append("tspan")
        .attr("x", 0)
        .attr("y", y + lineHeight)
        // .style("font-size", fontSize)
        .attr("dy", dy + "px");


    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > (width - 24)) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", lineHeight + dy + "px")
          // .style("font-size", fontSize)
          .text(word);
      }
    }
  });
}

export class VegaSignalListener {
  constructor(name, handler) {
    this.name = name;
    this.handler = handler;
  }
}

export function downloadTxtFile(data, name) {
  const element = document.createElement("a");
  const file = new Blob([data], { type: 'text/plain' });
  element.href = URL.createObjectURL(file);
  element.download = name + ".txt";
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
}

export const sections =

{
  ALTA_FORMAZIONE: [
    {
      icon: iconSchool,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_1.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_1.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_1.FULL_TEXT,
      iframeURL: 'didattica/graduated-distribution',
      layout: 'full',
      height: 700,
      codeName: 'graduated_distribution'
    },
    {
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_2.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_2.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_2.FULL_TEXT,
      iframeURL: 'didattica/graduated-distribution-per-classi',
      layout: 'full',
      height: 900,
      codeName: 'graduated_distribution_per_classi'
    },
    {
      icon: iconGeo,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_3.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_3.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_3.FULL_TEXT,
      iframeURL: 'didattica/provenienza-degli-immatricolati',
      layout: 'full',
      height: 830,
      codeName: 'provenienza_degli_immatricolati'
    },
    {
      icon: iconGeo,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_4.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_4.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_4.FULL_TEXT,
      iframeURL: 'didattica/students-out-toscana',
      layout: 'full',
      height: 540,
      codeName: 'studenti_fuori_toscana'
    },
    {
      icon: iconDiploma,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_5.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_5.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_5.FULL_TEXT,
      iframeURL: 'didattica/sankey-diploma-per-classi',
      layout: 'left',
      height: 880,
      codeName: 'sankey_diploma_per_classi'
    },
    {
      icon: iconDiploma2,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_6.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_6.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_6.FULL_TEXT,
      iframeURL: 'didattica/laureati-triennali',
      layout: 'full',
      height: 700,
      codeName: 'laureati_triennali'
    },
    {
      icon: iconBoard,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_7.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_7.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_7.FULL_TEXT,
      component: DataVizUstatIsotypesMaster,
      layout: 'left',
      height: 620,
      codeName: 'master_iscritti_diplomati'
    },
    {
      icon: iconBoard,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_8.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_8.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_8.FULL_TEXT,
      component: DataVizUstatPostgraduatesMaster,
      layout: 'full',
      height: 620,
      codeName: 'dove_master'
    },
    {
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_9.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_9.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_9.FULL_TEXT,
      component: DataVizUstatIsotypesPHD,
      layout: 'full',
      height: 700,
      codeName: 'dottorati_iscritti_diplomati'
    },
    {
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_10.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_10.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_10.FULL_TEXT,
      component: DataVizUstatPostgraduatesPHD,
      layout: 'full',
      height: 620,
      codeName: 'dove_dottorati'
    },
    {
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_11.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_11.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_11.FULL_TEXT,
      iframeURL: 'didattica/students-professors-ratio',
      layout: 'full',
      height: 790,
      codeName: 'studenti_professors_ratio'
    },
    {
      icon: iconGeo,
      title: strings.ALTA_FORMAZIONE.CARDS.CARD_12.TITLE,
      description: strings.ALTA_FORMAZIONE.CARDS.CARD_12.DESCRIPTION,
      fullText: strings.ALTA_FORMAZIONE.CARDS.CARD_12.FULL_TEXT,
      component: DataVizErasmusPlus,
      layout: 'full',
      height: 500,
      codeName: 'progetti_erasmus'
    }
  ].map((o, i) => {
    o.id = i + 1;
    return o;
  }),
  RICERCA_INNOVAZIONE: [
    {
      icon: iconMagnet,
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_1.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_1.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_1.FULL_TEXT,
      iframeURL: 'ricerca-e-universita/progetti-professor-ratio',
      layout: 'full',
      height: 430,
      codeName: 'progetti_professor_ratio'
    },
    {
      icon: iconMagnet2,
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_2.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_2.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_2.FULL_TEXT,
      iframeURL: 'ricerca-e-universita/progetti-partner',
      layout: 'full',
      height: 710,
      codeName: 'progetti_partner'
    },
    {
      icon: iconMagnet2,
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_3.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_3.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_3.FULL_TEXT,
      iframeURL: 'ricerca-e-imprese/progetti-partner-imprese',
      layout: 'full',
      height: 640,
      codeName: 'progetti_partner_imprese'
    },
    {
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_4.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_4.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_4.FULL_TEXT,
      iframeURL: 'ricerca-e-universita/progetti-programma',
      layout: 'full',
      height: 760,
      codeName: 'progetti_programma'
    },
    {
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_5.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_5.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_5.FULL_TEXT,
      iframeURL: 'ricerca-e-imprese/progetti-programma-imprese',
      layout: 'full',
      height: 680,
      codeName: 'progetti_programma_imprese'
    },
    {
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_6.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_6.DESCRIPTION,
      component: DataVizPublicationsBumpchart,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_6.FULL_TEXT,
      layout: 'left',
      height: 620,
      codeName: 'evoluzione_ambiti_ricerca'
    },
    {
      icon: iconRocket,
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_7.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_7.DESCRIPTION,
      component: DataVizSpinoffs,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_7.FULL_TEXT,
      layout: 'full',
      height: 500,
      codeName: 'toscana_spinoff'
    },
    {
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_8.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_8.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_8.FULL_TEXT,
      iframeURL: 'docenti-e-ricercatori/distribuzione-eta-ruolo-cunarea',
      layout: 'full',
      height: 540,
      codeName: 'distribuzione_eta_ruolo_cunarea'
    },
    {
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_9.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_9.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_9.FULL_TEXT,
      iframeURL: 'docenti-e-ricercatori/distribuzione-genere-ruolo-areacun',
      layout: 'full',
      height: 520,
      codeName: 'distribuzione_genere_ruolo_areacun'
    },
    {
      icon: iconTeacher,
      title: strings.RICERCA_INNOVAZIONE.CARDS.CARD_10.TITLE,
      description: strings.RICERCA_INNOVAZIONE.CARDS.CARD_10.DESCRIPTION,
      fullText: strings.RICERCA_INNOVAZIONE.CARDS.CARD_10.FULL_TEXT,
      iframeURL: 'docenti-e-ricercatori/distribuzione-ruolo-ssd',
      layout: 'full',
      height: 620,
      codeName: 'distribuzione_ruolo_ssd'
    }
  ].map((o, i) => {
    o.id = i + 1;
    return o;
  }),
  RETI_COLLABORAZIONE: [
    {
      icon: iconNetwork,
      title: strings.RETI_COLLABORAZIONE.CARDS.CARD_1.TITLE,
      description: strings.RETI_COLLABORAZIONE.CARDS.CARD_1.DESCRIPTION,
      fullText: strings.RETI_COLLABORAZIONE.CARDS.CARD_1.FULL_TEXT,
      component: DataVizNetworkCTN,
      layout: 'full',
      height: 1050,
      codeName: 'ctn_network'
    },
    {
      icon: iconNetwork2,
      title: strings.RETI_COLLABORAZIONE.CARDS.CARD_2.TITLE,
      description: strings.RETI_COLLABORAZIONE.CARDS.CARD_2.DESCRIPTION,
      component: DataVizNetworkCORDIS,
      fullText: strings.RETI_COLLABORAZIONE.CARDS.CARD_2.FULL_TEXT,
      layout: 'full',
      height: 1650,
      codeName: 'cordis_network'
    }
  ].map((o, i) => {
    o.id = i + 1;
    return o;
  })
}
